// Dependency
import React from 'react';

// Components
import MarketSwitcher from "../../market-switcher/market-switcher";
//import WrongMarket from "../../market-switcher/wrong-market";

// Styles
import * as styles from './modal-flyin.module.scss';

// Assets
import iconClose from './assets/icon-close.svg';

// Template
const ModalFlyIn = ({ direction, isOpen, flyinToggle, country }) => {
  return (
    <div className={`
      ${styles.modalFlyIn}
      ${isOpen ? styles.isOpen : ''}
    `}>
      <div className={`
        ${styles.modalFlyIn__content}
        ${direction === 'left' ? styles.fromLeft : ''}
        ${direction === 'right' ? styles.fromRight : ''}
      `}>
        <div>
          <button className={`${styles.modalFlyIn__close}`} onClick={flyinToggle}>
            <img src={iconClose} alt={''} />
          </button>
        </div>

{/*
        <WrongMarket />
*/}
        <MarketSwitcher country={country} />

{/*        <h2>100 dagars nöjd kundgaranti</h2>
        <p>Som kund hos Flowlife har du alltid 100 dagars nöjd kund-garanti på ditt köp.</p>
        <p>Garantin omfattar samtliga produkter i vårt sortiment.</p>
        <p>Det innebär att du i lugn och ro och över tid kan lära känna och testa dina inhandlade produkter för att säkerställa att köpet lever upp till dina förväntningar och returnera dem om du inte skulle vara helt tillfreds.</p>
        <p>För att återsända en produkt, var god fyll i och skicka in formuläret nedan:</p>
        <a href="https://flowlife-retur.azurewebsites.net/">https://flowlife-retur.azurewebsites.net/</a>
        <p>När formuläret är ifyllt och inskickat kommer en förbetald retursedel att landa i din mejlkorg.</p>
        <p>Den ska du använda för att skicka tillbaka produkten till oss. Så fort produkten nått oss gör vi en återbetalning på ditt köp. Återbetalningen sker med det betalsätt som användes vid ditt köp.</p>*/}
      </div>
      <button className={`
        ${styles.modalFlyIn__overlay}
        ${direction === 'left' ? styles.fromLeft : ''}
        ${direction === 'right' ? styles.fromRight : ''}
      `} onClick={flyinToggle}>
        <span className={`${styles.modalFlyIn__close}`}>Close</span>
      </button>
    </div>
  );
};

export default ModalFlyIn;